import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../../common/Header';
import LocateProductManual from './LocateProductManual';
import SupportNav from '../SupportNav';
import { branch } from 'baobab-react/higher-order';
import Breadcrumb from '../../common/Breadcrumb';
import BreadcrumbItem from '../../common/BreadcrumbItem';

class ProductManuals extends Component {	
	render() {		
		const product = this.props.product ? this.props.product[0] : this.props.product;
		const name = product ? `: ${product.name}` : '';
		const description = product ? `the SentrySafe ${product.name}` : 'your SentrySafe';
		return (
			<div className="product-manuals">
				<Helmet>
					<title>Product Manuals{name} | SentrySafe</title>
					<meta name="description" content={`Download a copy of ${description} product manual.`} />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Support" path="/support" />
					<BreadcrumbItem label="Product Manuals" />
				</Breadcrumb>

				<SupportNav />

				<Header
					title="Product Manuals"
					description="Download your product manual."
				/>
		
				<LocateProductManual product={ this.props.product } />
			</div>
		);
	}
};
export default branch({
	product: ['product']
}, ProductManuals);


// WEBPACK FOOTER //
// ./src/pages/support/productManuals/Index.js